import countryCodesList from "country-codes-list";

/**
 * The full ISO 3166-1 list of English country names, keyed by alpha-2 code
 * ("NL" -> "Netherlands").
 */
export const countryNamesByAlpha2Code = countryCodesList.customList(
    // This is a bug in the country-codes-list package, but it's not worth fixing.
    "countryCode" as unknown as any,
    "{countryNameEn}"
) as Record<string, string>;

/**
 * Resolves a country to its English name, e.g. "NL" -> "Netherlands".
 *
 * Accepts an ISO 3166-1 alpha-2 code (how host location addresses store the
 * country) as well as a name that is already spelled out (how Mapbox returns
 * it). Anything that is neither is passed through unchanged: an unrecognised
 * value still says more about where a result is than no value at all.
 */
export const getCountryName = (country?: string | null): string | undefined => {
    const trimmed = country?.trim();
    if (!trimmed) {
        return undefined;
    }
    return countryNamesByAlpha2Code[trimmed.toUpperCase()] ?? trimmed;
};
